var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAtmIcnArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 10,
    viewBox: "0 0 29 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.99.768L28.243 5 23.99 9.232z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 4h24v2H0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtmIcnArrow);
export default __webpack_public_path__ + "static/media/atm-icn-arrow.d31ad60825a5f6637970101a9187cf33.svg";
export { ForwardRef as ReactComponent };